import { cva } from 'cva'

const baseStyle = cva({
  base: ['mx-auto'],
  variants: {
    size: {
      center: ['mobile:min-w-[360px] tablet:max-w-[480px]'],
      full: [],
    },
  },

  defaultVariants: {
    size: 'center',
  },
})

export const bottomSheetOverlayStyle = cva({
  base: ['fixed inset-0 z-50 bg-[#1C1C1C]/70', 'right-[var(--removed-body-scroll-bar-size)]', baseStyle()],
})

export const bottomSheetDragHandleStyle = cva({
  base: ['mx-auto mt-4 mb-3 h-1 w-10 bg-gray-200 rounded-[11px]'],
})

export const bottomSheetStyle = cva({
  base: [
    [
      baseStyle({ size: 'center' }),
      // 위치 및 z-index
      'fixed inset-x-0 bottom-0 z-[51] pb-[calc(var(--safe-area-inset-bottom) + 12.5px)] overflow-visible',
      'right-[var(--removed-body-scroll-bar-size)]',
      // 크기
      'h-auto',
      // 레이아웃
      'flex flex-col gap-2',
      // 스타일
      'rounded-t-[20px] bg-white',
    ],
  ],

  variants: {
    size: {
      full: ['h-[calc(100dvh-80px)]'],
      hug: ['max-h-[calc(100dvh-80px)]'],
      'fixed-80': ['h-[calc(80dvh-80px)]'],
    },
  },

  defaultVariants: {
    size: 'full',
  },
})

export const bottomSheetDoNotShowTodayContainerStyle = cva({
  base: ['absolute -top-5', 'right-4', 'flex items-center', 'pointer-events-auto', '-translate-y-full'],
})

export const bottomSheetDoNotShowTodayLabelStyle = cva({
  base: ['flex items-center gap-2', 'text-white text-[14px]', 'cursor-pointer'],
})

export const bottomSheetDoNotShowTodayTextStyle = cva({
  base: ['inline-flex items-center gap-1.5', 'text-[14px] font-medium'],
})
